import { Eye } from 'lucide-react';

import { useOperator } from '@/features/auth/operator-context';

/**
 * Persistent banner shown while "view as user" is active.
 *
 * The brief requires impersonation be visually unmistakable and fully audited.
 * It uses the info accent rather than red: impersonation is read-only and not
 * itself destructive, and red must keep meaning danger alone.
 */
export function ImpersonationBanner() {
  const { impersonating, stopImpersonating } = useOperator();

  if (!impersonating) return null;

  return (
    <div
      role="status"
      className="sticky top-[59px] z-70 flex flex-wrap items-center gap-x-3 gap-y-1 border-b px-3.5 py-2"
      style={{
        background: 'rgba(var(--info-rgb), 0.14)',
        borderColor: 'rgba(var(--info-rgb), 0.4)',
      }}
    >
      <Eye size={14} className="text-info flex-none" aria-hidden />
      <span className="text-tx text-[13px] font-medium">
        Viewing as <span className="font-mono">@{impersonating.username}</span>
      </span>
      <span className="text-info-soft font-mono text-[10.5px] tracking-[0.1em] uppercase">
        read-only · fully audited
      </span>
      <button
        type="button"
        onClick={stopImpersonating}
        className="text-tx hover:bg-elev ml-auto rounded-md border px-2.5 py-1 text-xs font-medium"
        style={{ borderColor: 'rgba(var(--info-rgb), 0.5)' }}
      >
        Exit impersonation
      </button>
    </div>
  );
}
